import Checkbox from "@mui/material/Checkbox";
// material ui components
import Switch from "@mui/material/Switch";
import classNames from "classnames";
// firebase
import { fetchAndActivate, getValue } from "firebase/remote-config";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import OutlinedButton from "../../../components/common/OutlinedButton";
import PrimaryButton from "../../../components/common/PrimaryButton";
import Spinner from "../../../components/common/Spinner";
// components
import TextArea from "../../../components/forms/textarea";
import { InputType } from "../../../components/forms/textarea/TextArea";
import { remoteConfig } from "../../../firebase/firebase";
// typings
import {
  EFeePayee,
  IContractDetailsBody,
  ItemDetailsDTO,
} from "../../../setup/api/services/contract/models";
// helpers
import { ERRORMESSAGES, FIELDS, NEW_TRANSACTION } from "./constant";
// styles
import styles from "./newTransaction.module.scss";
interface Props {
  handleStepTwo: (
    price: IContractDetailsBody["itemPrice"],
    termsAccepted: boolean,
    sar: number,
    shippingFee: IContractDetailsBody["shipment"]["fee"],
    showSippingFee: boolean
    // feePayee: EFeePayee,
    // inspectionPeriod: number,
    // deliveryInDays: number
  ) => void;
  loading: boolean;
  priceProps?: IContractDetailsBody["itemPrice"];
  termsAcceptedProps?: boolean;
  shippingFeeProps?: IContractDetailsBody["shipment"]["fee"];
  showShippingFeeProps?: boolean;
  handleBack: () => void;
  // feePayeeProps?: ItemDetailsDTO["feePayee"];
  // inspectionPeriodProps?: ItemDetailsDTO["inspectionPeriod"];
  // deliveryInDaysProps?: ItemDetailsDTO["deliveryInDays"];
  editContract?: boolean;
}

type RemoteConfig = {
  _source: string;
  _value: string;
};

const AddPriceForm = ({
  handleStepTwo,
  loading,
  priceProps = "",
  termsAcceptedProps = false,
  shippingFeeProps = "",
  showShippingFeeProps = false,
  // feePayeeProps,
  // inspectionPeriodProps,
  // deliveryInDaysProps,
  handleBack,
  editContract,
}: Props) => {
  const [price, setPrice] = useState<IContractDetailsBody["itemPrice"]>(0);
  const [sar, setSar] = useState(0.0);
  const [shippingFee, setShippingFee] =
    useState<IContractDetailsBody["shipment"]["fee"]>(0);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showSippingFee, setShowShippingFee] = useState(false);

  const [comission, setCommission] = useState<number>(0);
  const [maxProductPrice, setMaxProductPrice] = useState<number>(5000);
  const [maxShipmentFee, setMaxShipmentFee] = useState<number>(1000);
  // const [feePayee, setFeePayee] = useState<ItemDetailsDTO["feePayee"]>(
  //   EFeePayee.PROVIDER
  // );
  // const [inspectionPeriod, setInspectionPeriod] =
  //   useState<ItemDetailsDTO["inspectionPeriod"]>(5);
  // const [deliveryInDays, setdeliveryInDays] =
  //   useState<ItemDetailsDTO["deliveryInDays"]>(5);
  const { t } = useTranslation();

  useEffect(() => {
    if (priceProps) setPrice(priceProps);
    if (termsAcceptedProps) setTermsAccepted(termsAcceptedProps);
    if (shippingFeeProps) setShippingFee(shippingFeeProps);
    if (showShippingFeeProps) setShowShippingFee(showShippingFeeProps);
    // if (feePayeeProps) setFeePayee(feePayeeProps);
    // if (inspectionPeriodProps) setInspectionPeriod(inspectionPeriodProps);
    // if (deliveryInDaysProps) setdeliveryInDays(deliveryInDaysProps);
  }, [priceProps, termsAcceptedProps, shippingFeeProps, showShippingFeeProps]);

  useEffect(() => {
    try {
      fetchAndActivate(remoteConfig)
        .then(() => {
          const comission = getValue(
            remoteConfig,
            "commission"
          ) as unknown as RemoteConfig;
          const max_product_price = getValue(
            remoteConfig,
            "max_product_price"
          ) as unknown as RemoteConfig;
          const max_shipment_fee = getValue(
            remoteConfig,
            "max_shipment_fee"
          ) as unknown as RemoteConfig;
          // const delivery_period = getValue(
          //   remoteConfig,
          //   "delivery_period"
          // ) as unknown as RemoteConfig;

          // const inspection_period = getValue(
          //   remoteConfig,
          //   "inspection_period"
          // ) as unknown as RemoteConfig;

          /* eslint-disable */
          comission?._value && setCommission(Number(comission?._value));
          max_product_price?._value &&
            setMaxProductPrice(Number(max_product_price?._value));
          max_shipment_fee?._value &&
            setMaxShipmentFee(Number(max_shipment_fee?._value));

          // delivery_period?._value &&
          //   !deliveryInDaysProps &&
          //   setdeliveryInDays(Number(delivery_period?._value));

          // inspection_period?._value &&
          //   !inspectionPeriodProps &&
          //   setInspectionPeriod(Number(inspection_period?._value));
        })
        .catch((err) => {
          setCommission(0);
        });
    } catch (error) {
      setCommission(0);
    }
  }, []);

  const configureNumber = (number) => {
    const arabicNumbers = [
      /٠/g,
      /١/g,
      /٢/g,
      /٣/g,
      /٤/g,
      /٥/g,
      /٦/g,
      /٧/g,
      /٨/g,
      /٩/g,
    ];
    if (typeof number === "string") {
      for (let i = 0; i < arabicNumbers.length; i++) {
        number = number.replace(arabicNumbers[i], i);
      }
    }
    return number;
  };

  useEffect(() => {
    const priceConverted = Number(configureNumber(price));
    const calculatedSar = (
      Number(priceConverted) * (comission || 0.03)
    ).toFixed(2);
    if (calculatedSar !== null && !isNaN(Number(calculatedSar))) {
      setSar(Number(calculatedSar));
    }
  }, [price]);

  return (
    <div className={styles["form_product"]}>
      <div className={styles["top_section_product"]}>
        <h3 className={styles["form-header"]}>{t("PRICE_PRODUCTS")}</h3>
        <div className={styles["sar_row"]}>
          <div className={styles["sar_container"]}>
            <p className={"hint2"}>{t("SERVICE_FEE")}</p>
            <div className={styles.sar_fee_wrapper}>
              <p className={classNames("hint2", styles["float_left"])}>
                <span>{t("RIAL")}</span>
              </p>
              <p className={styles["sar_fee"]}>
                <span>{sar}</span>
              </p>
            </div>
          </div>
          <div style={{ display: "flex", flex: 0.65 }}>
            <TextArea
              label={t("WRITE_PRICE")}
              maxCharacters={9}
              defaultValue={priceProps}
              required={true}
              type={InputType.NUMBER}
              errorFormat={Number(configureNumber(price)) > maxProductPrice}
              errorMessage={
                Number(configureNumber(price)) > maxProductPrice
                  ? `${ERRORMESSAGES.PRICE_ERROR} ${maxProductPrice}`
                  : undefined
              }
              height={"4.2rem"}
              handleChange={(e) => setPrice(e.target.value)}
              description={NEW_TRANSACTION.SR}
            />
          </div>
        </div>
        {/* <h3 className={styles["form-header"]}>{t("lbl_waffy_fee_payee")}</h3> */}
        {/* <div className={styles["fee_selector_container"]}>
          <div
            onClick={() => setFeePayee(EFeePayee.BOTH)}
            className={styles["selector_button"]}>
            <p
              className={classNames(
                styles["hint"],
                feePayee === EFeePayee.BOTH
                  ? styles["primary"]
                  : styles["selector"]
              )}>
              {t("lbl_the_seller_or_buyer")}
            </p>
            <img
              src={
                feePayee === EFeePayee.BOTH
                  ? "/assets/images/svg/feePayeeBothSelected.svg"
                  : "/assets/images/svg/feePayeeBoth.svg"
              }
              alt="both"
            />
            {feePayee === EFeePayee.BOTH && (
              <div className={styles["selected"]} />
            )}
          </div>
          <div
            onClick={() => setFeePayee(EFeePayee.CUSTOMER)}
            className={styles["selector_button"]}>
            <p
              className={classNames(
                styles["hint"],
                feePayee === EFeePayee.CUSTOMER
                  ? styles["primary"]
                  : styles["selector"]
              )}>
              {t("lbl_the_buyer")}
            </p>
            <img
              src={
                feePayee === EFeePayee.CUSTOMER
                  ? "/assets/images/svg/feePayeeSelected.svg"
                  : "/assets/images/svg/feePayee.svg"
              }
              alt="buyer"
            />
            {feePayee === EFeePayee.CUSTOMER && (
              <div className={styles["selected"]} />
            )}
          </div>
          <div
            onClick={() => setFeePayee(EFeePayee.PROVIDER)}
            className={styles["selector_button"]}>
            <p
              className={classNames(
                styles["hint"],
                feePayee === EFeePayee.PROVIDER
                  ? styles["primary"]
                  : styles["selector"]
              )}>
              {t("lbl_the_seller")}
            </p>
            <img
              src={
                feePayee === EFeePayee.PROVIDER
                  ? "/assets/images/svg/feePayeeSelected.svg"
                  : "/assets/images/svg/feePayee.svg"
              }
              alt="provider"
            />
            {feePayee === EFeePayee.PROVIDER && (
              <div className={styles["selected"]} />
            )}
          </div>
        </div>

        <h3 className={styles["form-header"]}>
          {t("lbl_enter_delivery_inspection_period")}
        </h3>

        <div className={classNames(styles["period_container"], styles["row"])}>
          <div className={styles["flex5"]}>
            <TextArea
              label={t("lbl_delivery_period")}
              maxCharacters={2}
              defaultValue={deliveryInDays}
              required={true}
              rangeSelector={[1, 30]}
              type={InputType.NUMBER}
              description={" "}
              errorFormat={
                Number(configureNumber(deliveryInDays)) > 30 ||
                Number(configureNumber(deliveryInDays)) < 1
              }
              errorMessage={
                Number(configureNumber(deliveryInDays)) > 30 ||
                Number(configureNumber(deliveryInDays)) < 1
                  ? t("lbl_delivery_period_error")
                  : undefined
              }
              height={"4.2rem"}
              handleChange={(e) => setdeliveryInDays(Number(e.target.value))}
            />
          </div>
          <div className={styles["flexDivider"]} />
          <div className={styles["flex5"]}>
            <TextArea
              label={t("lbl_inspection_period")}
              maxCharacters={2}
              defaultValue={inspectionPeriod}
              rangeSelector={[1, 30]}
              required={true}
              type={InputType.NUMBER}
              errorFormat={
                Number(configureNumber(inspectionPeriod)) > 30 ||
                Number(configureNumber(inspectionPeriod)) < 1
              }
              errorMessage={
                Number(configureNumber(inspectionPeriod)) > 30 ||
                Number(configureNumber(inspectionPeriod)) < 1
                  ? t("lbl_inspection_period_error")
                  : undefined
              }
              height={"4.2rem"}
              handleChange={(e) => setInspectionPeriod(Number(e.target.value))}
            />
          </div>
        </div> */}
        <h3 className={classNames(styles["form-header"], "mt2")}>
          {t("SHIPPING_DETAILS")}
        </h3>
        <div className={styles.shipment_container}>
          <div className={styles.shipment_wrapper}>
            <p className={"subtitle2"}>{t("IS_THERE_SHIPPMENT")}</p>
            <Switch
              checked={showSippingFee}
              onChange={() => setShowShippingFee(!showSippingFee)}
              defaultChecked
            />
          </div>
        </div>
        {showSippingFee && (
          <TextArea
            label={t("SHIPPING_FEE")}
            type={InputType.NUMBER}
            required={showSippingFee}
            defaultValue={shippingFeeProps}
            maxCharacters={8}
            errorFormat={Number(configureNumber(shippingFee)) > 30}
            errorMessage={
              Number(configureNumber(shippingFee)) > maxShipmentFee
                ? `${ERRORMESSAGES.SHIPPING_ERROR} ${maxShipmentFee}`
                : undefined
            }
            height={"4.2rem"}
            handleChange={(e) => setShippingFee(e.target.value)}
            description={FIELDS.RIAL}
          />
        )}
        <div className={styles["terms_condition"]}>
          <a
            className={styles.link}
            href={process.env.REACT_APP_TERMS_AND_CONDITION_URL}
            target="blank">
            <p className={classNames("subtitle2", "primary")}>
              {t("lbl_terms_condition")}
            </p>
            <p className={classNames("subtitle2", "primary")}>
              {t("lbl_accept_terms_condition")}
            </p>
          </a>

          <Checkbox
            checked={termsAccepted}
            onChange={() => setTermsAccepted(!termsAccepted)}
            color="primary"
            className={styles.checkBox}
          />
        </div>
      </div>
      <div className={styles["bottom_section_product"]}>
        <div className={styles.left}>
          <PrimaryButton
            disabled={
              // Number(configureNumber(inspectionPeriod)) > 30 ||
              // Number(configureNumber(inspectionPeriod)) < 1 ||
              // Number(configureNumber(deliveryInDays)) > 30 ||
              // Number(configureNumber(deliveryInDays)) < 1 ||
              Number(configureNumber(price)) === 0 ||
              Number(configureNumber(price)) > maxProductPrice ||
              Number(configureNumber(price)) <= 0 ||
              !termsAccepted ||
              (showSippingFee &&
                (!shippingFee ||
                  Number(configureNumber(shippingFee)) > maxShipmentFee ||
                  Number(configureNumber(shippingFee)) <= 0)) ||
              loading
            }
            id={`create_contract_add_price`}
            onClick={() =>
              handleStepTwo(
                configureNumber(price),
                termsAccepted,
                sar,
                configureNumber(shippingFee),
                showSippingFee
                // feePayee,
                // inspectionPeriod,
                // deliveryInDays
              )
            }>
            {loading ? (
              <Spinner />
            ) : editContract ? (
              `${t("lbl_edit_contract")}`
            ) : (
              `${t("CREATE_TRANSACTION")}`
            )}
          </PrimaryButton>
        </div>
        <div className={styles.mid} />
        <div className={styles.right}>
          <OutlinedButton
            id={`create_contract_add_product_back`}
            onClick={handleBack}>
            {NEW_TRANSACTION.BACK}
          </OutlinedButton>
        </div>
      </div>
    </div>
  );
};

export default AddPriceForm;
